import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

import MiniBarChart from '../../components/dashboard/MiniBarChart';

const DashboardPsicologico = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        citas_totales: null, 
        citas_pendientes: null, 
        citas_aprobadas: null, 
        citas_canceladas: null, 
        dia_mas: null, 
        dia_menos: null, 
        horario_mas: null, 
        horario_menos: null, 
        usuario_citas: null, 
        usuario_ultimo: null, 
        usuario_proximo: null, 
        citas_mes: null, 
        citas_semana: null, 
        citas_hoy: null, 
        mensajes: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('psicologico'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                citas_totales: detalles.citas_totales, 
                citas_pendientes: detalles.citas_pendientes, 
                citas_aprobadas: detalles.citas_aprobadas, 
                citas_canceladas: detalles.citas_canceladas, 
                dia_mas: detalles.dia_mas, 
                dia_menos: detalles.dia_menos, 
                horario_mas: detalles.horario_mas, 
                horario_menos: detalles.horario_menos, 
                usuario_ultimo: detalles.usuario_ultimo, 
                usuario_citas: detalles.usuario_citas, 
                usuario_proximo: detalles.usuario_proximo, 
                citas_mes: detalles.citas_mes, 
                citas_semana: detalles.citas_semana, 
                citas_hoy: detalles.citas_hoy, 
                mensajes: detalles.mensajes
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    Bienvenido {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}
                </h4>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Citas</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_totales != null && dashboardData.citas_totales != undefined ? formatNumber(dashboardData.citas_totales, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">totales</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_pendientes != null && dashboardData.citas_pendientes != undefined ? formatNumber(dashboardData.citas_pendientes, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">próximas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_aprobadas != null && dashboardData.citas_aprobadas != undefined ? formatNumber(dashboardData.citas_aprobadas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">aprobadas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_canceladas != null && dashboardData.citas_canceladas != undefined ? formatNumber(dashboardData.citas_canceladas, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">canceladas</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Totales', valor: dashboardData.citas_totales || 0 },
                                    { nombre: 'Próximas', valor: dashboardData.citas_pendientes || 0 },
                                    { nombre: 'Aprobadas', valor: dashboardData.citas_aprobadas || 0 },
                                    { nombre: 'Canceladas', valor: dashboardData.citas_canceladas || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>

            <div className="col-md-3 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Dias</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_mas != null && dashboardData.dia_mas != undefined ? dashboardData.dia_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más citado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_menos != null && dashboardData.dia_menos != undefined ? dashboardData.dia_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos citado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-3 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Horarios</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_mas != null && dashboardData.horario_mas != undefined ? dashboardData.horario_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más citado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_menos != null && dashboardData.horario_menos != undefined ? dashboardData.horario_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos citado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Destacados</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.usuario_citas != null && dashboardData.usuario_citas != undefined ? dashboardData.usuario_citas : 'Sin definir'}</p>
                                <p className="subtitulo">usuario con mas citas</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.usuario_ultimo != null && dashboardData.usuario_ultimo != undefined ? dashboardData.usuario_ultimo : 'Sin definir'}</p>
                                <p className="subtitulo">última cita</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.usuario_proximo != null && dashboardData.usuario_proximo != undefined ? dashboardData.usuario_proximo : 'Sin definir'}</p>
                                <p className="subtitulo">próxima cita</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Mis acciones</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_mes != null && dashboardData.citas_mes != undefined ? dashboardData.citas_mes : 'Sin definir'}</p>
                                <p className="subtitulo">citas en el mes</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.citas_semana != null && dashboardData.citas_semana != undefined ? dashboardData.citas_semana : 'Sin definir'}</p>
                                <p className="subtitulo">citas en la semana</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.citas_hoy != null && dashboardData.citas_hoy != undefined ? dashboardData.citas_hoy : 'Sin definir'}</p>
                                <p className="subtitulo">citas hoy</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.mensajes != null && dashboardData.mensajes != undefined ? dashboardData.mensajes : 'Sin definir'}</p>
                                <p className="subtitulo">mensajes sin leer</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardPsicologico;